import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { loopReturnsIntegrationQuery } from "modules/settings/lib/loopReturns/loopReturnsIntegrationQuery"
import {
  CreateIntegrationConfigurationSchema,
  DataResponse,
  UpsertLoopReturnsIntegrationSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof CreateIntegrationConfigurationSchema>>

export function useUpsertLoopReturnsIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof UpsertLoopReturnsIntegrationSchema>) => {
      const response = await axios.post<Response>(`/integrations/loopreturns/configuration`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: loopReturnsIntegrationQuery().queryKey })
    },
  })
}
